import * as React from 'react';
export const idealSvg = React.forwardRef(function idealSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.589 2H.984v12.07H9.59c4.324 0 6.427-1.985 6.427-6.07 0-2.061-.626-3.632-1.862-4.668C13.062 2.415 11.483 2 9.59 2zM0 1l9.774.003c2.057.032 3.796.594 5.034 1.633a5.766 5.766 0 0 1 1.613 2.204C16.805 5.751 17 6.815 17 8c0 2.48-.74 4.331-2.2 5.505-1.2.964-2.892 1.465-5.026 1.495H0zm6.929 11.076V3.74h2.525-.116c2.383 0 4.92.887 4.92 4.178 0 3.479-2.536 4.156-4.92 4.156h.116zM2.497 7.575h2.81v4.39h-2.81zM5.518 5.38c0 .827-.712 1.497-1.59 1.497-.878 0-1.59-.67-1.59-1.497 0-.826.712-1.497 1.59-1.497.878 0 1.59.67 1.59 1.497z',
      fillRule: 'evenodd',
    }),
  );
});
idealSvg.defaultProps = {
  height: '16',
  viewBox: '0 0 17 16',
  width: '17',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ideal = {
  category: 'paymentmethod',
  colorable: true,
  name: 'ideal',
  svg: idealSvg,
};
